import { IonicRouteStrategy } from '@ionic/angular';

export class AppRouteStrategy extends IonicRouteStrategy {
  override shouldReuseRoute() {
    return false;
  }
}
